import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IAlfabetizacaoSeminario {
    codigo: number;
    name: string;
    email: string;
    phone: string;
    rg: string;
    cpf: string;
    dateBirth: string;
    address: Record<string, any>;
    termParticipatedFree: boolean;
    termDadosUse: boolean;
}

class AlfabetizacaoSeminario extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    name: string = '';

    @jsonProperty(String)
    email: string = '';

    @jsonProperty(String)
    phone: string = '';

    @jsonProperty(String)
    rg: string = '';

    @jsonProperty(String)
    cpf: string = '';

    @jsonProperty(String)
    dateBirth: string = '';

    @jsonProperty(Object)
    address: Record<string, any> = {};

    @jsonProperty(Boolean)
    termParticipatedFree: boolean = false;

    @jsonProperty(Boolean)
    termDadosUse: boolean = false;

    fromJSON(json: IAlfabetizacaoSeminario, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.name = json.name;
        this.email = json.email;
        this.phone = json.phone;
        this.rg = json.rg;
        this.cpf = json.cpf;
        this.dateBirth = json.dateBirth;
        this.address = json.address;
        this.termParticipatedFree = json.termParticipatedFree;
        this.termDadosUse = json.termDadosUse;

        return this;
    }
}

export default AlfabetizacaoSeminario;
